import { Search, X, ArrowDownUp } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field, fieldInputCls } from "@/components/Field";
import { useT } from "@/lib/i18n";
import { useSettings } from "@/context/SettingsContext";

export const EMPTY_FILTERS = { q: "", track: "", event_type: "", date_from: "", date_to: "", order: "desc" };

export const EventFilters = ({ filters, setFilters, tracks }) => {
  const { t } = useT();
  const { visibleTypes } = useSettings();
  const set = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });
  return (
    <div data-testid="event-filters" className="bg-[#12141C] border border-[#282D3D] rounded-sm p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1.4fr_1.4fr_1fr_1fr_auto] gap-3 items-end">
      <Field label={t("event_name")}>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-3 text-slate-500" />
          <Input data-testid="filter-name-input" placeholder={t("search_name")} value={filters.q} onChange={set("q")} className={`${fieldInputCls} pl-9`} />
        </div>
      </Field>
      <Field label={t("track")}>
        <Input data-testid="filter-track-input" list="tracks-list" value={filters.track} onChange={set("track")} className={fieldInputCls} />
        <datalist id="tracks-list">{tracks.map((tr) => <option key={tr} value={tr} />)}</datalist>
      </Field>
      <Field label={t("event_type")}>
        <Select value={filters.event_type || "all"} onValueChange={(v) => setFilters({ ...filters, event_type: v === "all" ? "" : v })}>
          <SelectTrigger data-testid="filter-type-select" className={fieldInputCls}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("all_types")}</SelectItem>
            {visibleTypes.map((ty) => <SelectItem key={ty} value={ty} data-testid={`filter-type-${ty}`}>{t(`type_${ty}`)}</SelectItem>)}
          </SelectContent>
        </Select>
      </Field>
      <Field label={t("date_from")}>
        <Input data-testid="filter-date-from" type="date" value={filters.date_from} onChange={set("date_from")} className={fieldInputCls} />
      </Field>
      <Field label={t("date_to")}>
        <Input data-testid="filter-date-to" type="date" value={filters.date_to} onChange={set("date_to")} className={fieldInputCls} />
      </Field>
      <div className="flex gap-2">
        <button data-testid="filter-order-btn" title={filters.order === "asc" ? t("order_asc") : t("order_desc")}
          onClick={() => setFilters({ ...filters, order: filters.order === "asc" ? "desc" : "asc" })}
          className="h-10 w-10 flex items-center justify-center border border-[#282D3D] rounded-sm text-slate-400 hover:text-white hover:border-slate-500 transition-colors duration-200">
          <ArrowDownUp className="w-4 h-4" />
        </button>
        <button data-testid="filter-reset-btn" title={t("reset_filters")} onClick={() => setFilters(EMPTY_FILTERS)}
          className="h-10 w-10 flex items-center justify-center border border-[#282D3D] rounded-sm text-slate-400 hover:text-[#FF3B30] hover:border-[#FF3B30] transition-colors duration-200">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
